import type {z} from "zod";

import {AddMaterialNoteBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

const fields = AddMaterialNoteBody.shape;
export const addMaterialNoteFormSchema = zod.object({
  title: requiredStringSchema(fields.title, noteFieldLabelIds.title),
  content: requiredStringSchema(fields.content, noteFieldLabelIds.content),
});
export type AddMaterialNoteFormPayload = z.output<typeof addMaterialNoteFormSchema>;

export const draftAddMaterialNoteFormSchema = addMaterialNoteFormSchema.partial();
export type DraftAddMaterialNoteFormPayload = z.output<typeof draftAddMaterialNoteFormSchema>;
